const CARDS = [
  {
    title: '霸道总裁的契约新娘',
    author: '月下蝶影',
    tags: ['韩漫', '恋爱', '总裁'],
    status: '连载中',
    update: '更新至第89话',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20romance%20manga%20cover%20style%20illustration%2C%20beautiful%20couple%20in%20formal%20attire%20with%20soft%20warm%20lighting%2C%20Korean%20webtoon%20aesthetic%2C%20clean%20composition%20with%20gentle%20pink%20and%20cream%20tones%2C%20romantic%20atmosphere%2C%20simple%20elegant%20background&width=600&height=800&seq=manga-card-01&orientation=portrait',
  },
  {
    title: '暗夜猎魔人：觉醒',
    author: '黑瞳工作室',
    tags: ['国漫', '奇幻', '热血'],
    status: '连载中',
    update: '更新至第156话',
    img: 'https://readdy.ai/api/search-image?query=Action%20fantasy%20manga%20cover%20with%20warrior%20character%20holding%20sword%2C%20dramatic%20dark%20background%20with%20orange%20fire%20effects%2C%20Chinese%20manhua%20art%20style%2C%20dynamic%20pose%2C%20clean%20composition%2C%20vibrant%20contrast%20colors&width=600&height=800&seq=manga-card-02&orientation=portrait',
  },
  {
    title: '青梅竹马是吸血鬼',
    author: '星野琉璃',
    tags: ['日漫', '奇幻', '校园'],
    status: '已完结',
    update: '共120话 · 已完结',
    img: 'https://readdy.ai/api/search-image?query=School%20life%20fantasy%20manga%20cover%20with%20mysterious%20atmosphere%2C%20two%20students%20under%20cherry%20blossom%20tree%2C%20Japanese%20manga%20style%2C%20soft%20pink%20and%20purple%20tones%2C%20romantic%20and%20mysterious%20vibe%2C%20clean%20illustration&width=600&height=800&seq=manga-card-03&orientation=portrait',
  },
  {
    title: '重生之商业帝国',
    author: '云端之上',
    tags: ['韩漫', '都市', '逆袭'],
    status: '连载中',
    update: '更新至第67话',
    img: 'https://readdy.ai/api/search-image?query=Modern%20business%20drama%20manga%20cover%2C%20confident%20businessman%20in%20suit%20with%20city%20skyline%20background%2C%20Korean%20webtoon%20style%2C%20cool%20blue%20and%20gray%20tones%2C%20professional%20elegant%20aesthetic%2C%20clean%20composition&width=600&height=800&seq=manga-card-04&orientation=portrait',
  },
  {
    title: '狐妖大人请留步',
    author: '墨香铜臭',
    tags: ['国漫', '古风', '玄幻'],
    status: '连载中',
    update: '更新至第203话',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20manga%20cover%20with%20fox%20spirit%20character%2C%20traditional%20hanfu%20clothing%2C%20misty%20mountain%20background%2C%20Chinese%20manhua%20art%20style%2C%20warm%20golden%20and%20red%20tones%2C%20mystical%20atmosphere&width=600&height=800&seq=manga-card-05&orientation=portrait',
  },
  {
    title: '深海迷踪：深渊之眼',
    author: '深海鱼',
    tags: ['日漫', '悬疑', '科幻'],
    status: '连载中',
    update: '更新至第34话',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20sci-fi%20manga%20cover%20with%20deep%20ocean%20theme%2C%20mysterious%20underwater%20creature%20silhouette%2C%20dark%20blue%20and%20teal%20color%20palette%2C%20Japanese%20manga%20style%2C%20suspenseful%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=manga-card-06&orientation=portrait',
  },
  {
    title: '秘密花园的秘密',
    author: '春日暖阳',
    tags: ['韩漫', 'BL', '治愈'],
    status: '连载中',
    update: '更新至第78话',
    img: 'https://readdy.ai/api/search-image?query=Gentle%20slice%20of%20life%20manga%20cover%20with%20two%20characters%20in%20beautiful%20garden%20setting%2C%20Korean%20webtoon%20art%20style%2C%20soft%20pastel%20green%20and%20cream%20tones%2C%20warm%20sunlight%20effect%2C%20healing%20and%20peaceful%20atmosphere&width=600&height=800&seq=manga-card-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精选<strong>好看的漫画</strong>推荐，热门<strong>韩漫日漫国漫</strong>一网打尽
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {CARDS.slice(0, 7).map((card) => (
            <a
              key={card.title}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={`虫虫漫画网 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 text-[10px] font-bold rounded-full ${
                    card.status === '已完结'
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-primary-500 text-background-50'
                  }`}>
                    {card.status}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{card.author}</p>
                <div className="mt-2 flex flex-wrap gap-1">
                  {card.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-[10px] bg-background-100 text-foreground-600 rounded-md"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="mt-2 text-[11px] text-primary-500 font-medium">{card.update}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}